import React from 'react'

type Props = {
    className?  : string    // `entity-selector-list` / `entity-selector-glist` -- selector.scss keys off these

    onKeyDown?  : {(event: React.KeyboardEvent):void}
    children?   : any
}

// const debug = "EntitySelectorPane"
const debug = false

// The box under the search line, whatever a tab fills it with -- a tree, the
// shared glist, the user list. It is a flex child (`flex-1 min-h-0`), never a
// height subtracted from 100%.
//
// **It swallows the DEFAULT of mousedown, and that is the whole point.** Moving
// focus IS that default: every row down there is a plain div with an onClick and
// nothing focusable in it, so a click would otherwise blur the search box and
// leave focus on the body. The search box is where the arrow keys are read
// (`search/search-input.tsx` -> the tab -> the pane's `onKeyDown`), so from that
// click on, the keyboard would be dead until the user clicked back into the
// field. Cancelling the default keeps the caret where it belongs; the click
// itself is untouched, so rows, expand arrows and breadcrumbs behave as before.
//
// The cost is that pane text cannot be mouse-selected -- what a picker's list
// does anyway.
export default function EntitySelectorPane(props:Props) {

    const classes = Classes(props.className, "flex-1 min-h-0")

    const onMouseDown = (event: React.MouseEvent) => {
        debug && console.log(debug, 'onMouseDown -- keeping focus in the search field')
        return event.preventDefault()
    }

    return (
        <div className      = {classes}
             onKeyDown      = {props.onKeyDown}
             onMouseDown    = {onMouseDown}
        >
            {props.children}
        </div>
    )
}
